import React, { FC } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { FormStateType } from '../../../types'
import {
  Form, Grid, Button, StripeInput, LabelWrapper, Checkbox
} from '../../System'
import ROUTES from '../../utils/routes'
import { OrderSummary } from '../../Auth/OrderSummary'

type Props = {
  form: FormStateType;
  nextStep: () => void;
}

const PaymentStep: FC<Props> = ({ form, nextStep }) => {
  const { values, setValue } = form

  const canContinue = () => {
    if (values.agreeTerms !== 'yes') {
      return false
    }

    if (!values.card) {
      return false
    }

    if (values.card.error || !values.card.complete) {
      return false
    }

    return true
  }

  return (
    <Form>
      <Grid inLayout gap={12}>
        <LabelWrapper label="Order Summary">
          <OrderSummary
            items={[
              {
                ...values.subscription,
                label: values.subscription.name,
                subLabel: values.subscription.sizzle,
                imageURL:
                  'https://hello.socialcurator.com/getImageFromPath?imagePath=images/9822370-SC-11-2021-13.JPG'
              },
              {
                label: 'Social Curator Subscription',
                subLabel:
                  'Receive two months of access to Social Curator for FREE. Cancel anytime.',
                price: 0
              }
            ]}
          />
        </LabelWrapper>

        <LabelWrapper
          label="Card Information"
          errorMessage={values.card && values.card.error && values.card.error.message}
        >
          <StripeInput onChange={(card) => setValue('card', card)} />
        </LabelWrapper>
      </Grid>

      <Checkbox
        onChange={(checked) => setValue('agreeTerms', checked.target.checked ? 'yes' : 'no')}
        name="agreeTerms"
        label={(
          <>
            I agree to the{' '}
            <a
              href={ROUTES.external.termsOfServiceUrl}
              target="_blank"
              referrerPolicy="no-referrer"
              rel="noreferrer"
            >
              terms of service
            </a>{' '}
            and{' '}
            <a
              href={ROUTES.external.cancellationPolicyUrl}
              target="_blank"
              referrerPolicy="no-referrer"
              rel="noreferrer"
            >
              cancellation policy
            </a>
            . I acknowledge that upon purchase of S.O.S. I'm subscribing to Social Curator and will
            be charged $49 on{' '}
            {moment()
              .add(2, 'months')
              .format('MM/DD/YY')}{' '}
            unless I cancel my subscription, which can be canceled at any time without losing access
            to course content.
          </>
        )}
      />

      <Button
        isDisabled={!canContinue()}
        type="large"
        className="continue-btn"
        onClick={() => nextStep()}
      >
        CONFIRM PAYMENT
      </Button>
      <span className="auth-prompt">
        Already have an account? <Link to={ROUTES.user.login}>Sign In</Link>
      </span>
    </Form>
  )
}

export default PaymentStep
